import React, { useCallback, useMemo } from 'react';

import { PgWheelThemeConfigs } from '../../../../../jackpot/constants/pg-wheel-theme-configs';
import { useOutsideClick, useStore, useTranslation } from '../../../../../hooks';
import { dotFormatter, setTranslationValues } from '../../../../../helpers';
import { PGWheelInfo } from '../../../../../models';
import { PGWheelPopupTimer } from '../popup-timer';
import { T } from '../../../../../constants';

interface PGWheelAnnouncementPopupProps {
  wheelInfo: PGWheelInfo;
}

export const PGWheelAnnouncementPopup: React.FC<PGWheelAnnouncementPopupProps> = ({ wheelInfo }) => {

  const { minBetAmount, currencyCode, totalWinCount, poolAmount } = wheelInfo;

  const t = useTranslation();
  const { boostedJackpotStore, gameStore } = useStore();
  const { partnerId } = gameStore;

  const handleClose = useCallback(() => {
    boostedJackpotStore.setIsBoostedJackpotInitialPopup(false);
  }, [boostedJackpotStore]);

  const { modalRef, containerRef } = useOutsideClick(handleClose);

  const pgWheelMinBetAmountText = useMemo(() => {
    return setTranslationValues(t(T.PG_WHEEL_MIN_BET_AMOUNT), { minBetAmount: `${minBetAmount} ${currencyCode}` });
  }, [t, currencyCode, minBetAmount]);

  const pgWheelWinCountUpToText = useMemo(() => {
    return setTranslationValues(t(T.PG_WHEEL_WIN_COUNT_UP_TO), { count: totalWinCount });
  }, [t, totalWinCount]);

  return (
    <div className="boosted-popup-wrapper" ref={containerRef}>
      <div className="boosted-popup-inner version-1" ref={modalRef}>
        <p className="boosted-popup-title">
          {t(T.PG_WHEEL_ANOUNCEMENT_POPUP_TITLE)}
        </p>
        <div className="boosted-popup-wheel-cont">
          <div className="boosted-popup-wheel-duration-cont">
            <p className="boosted-popup-wheel-duration-title">
              {t(T.DURATION)}
            </p>
            <PGWheelPopupTimer date={wheelInfo.endDate} />
            <p className="boosted-popup-number">
              {dotFormatter(poolAmount)} <span>{currencyCode}</span>
            </p>
            <p className="boosted-popup-wheel-duration-title">
              {t(T.WINNING_COUNT)}
            </p>
            <p className="winners-count-text">
              {pgWheelWinCountUpToText}
            </p>
            <p className="winners-count-sub-text">
              {pgWheelMinBetAmountText}
            </p>
          </div>
          <button
            type="button"
            onClick={handleClose}
            className="boosted-popup-button"
            style={{ backgroundImage: `url(${PgWheelThemeConfigs[partnerId].buttonBackgroundImage})` }}
          >
            <span
              className="boosted-popup-button-text"
              style={{
                color: PgWheelThemeConfigs[partnerId].buttonTextColor,
                "--shadow-color": PgWheelThemeConfigs[partnerId].buttonShadowColor
              } as React.CSSProperties}
            >
                {t(T.OK)}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
